module.exports = __webpack_public_path__ + "img/t3-8.5979dd9b.jpg";